import { Route, Switch } from "react-router-dom";
import CartExperienceImprovementPage from "@faire/prototype-playground/workspace/tn/cart-experience-improvement";
import EnablingEmojiReactionMessengerPage from "@faire/prototype-playground/workspace/tn/enabling-emoji-reaction-messenger";
import HighlightMessengerPage from "@faire/prototype-playground/workspace/tn/highlight-messenger";
import MessengerPopupChatRevampPage from "@faire/prototype-playground/workspace/tn/messenger-popup-chat-revamp";
import ProminentMessengerIconPage from "@faire/prototype-playground/workspace/tn/prominent-messenger-icon";

export function TrungNguyenRoutes() {
  return (
    <Switch>
      <Route path="/tn/cart-experience-improvement" component={CartExperienceImprovementPage} />
      <Route path="/tn/enabling-emoji-reaction-messenger" component={EnablingEmojiReactionMessengerPage} />
      <Route path="/tn/highlight-messenger" component={HighlightMessengerPage} />
      <Route path="/tn/messenger-popup-chat-revamp" component={MessengerPopupChatRevampPage} />
      <Route path="/tn/prominent-messenger-icon" component={ProminentMessengerIconPage} />
    </Switch>
  );
}

export const slug = "tn";
